import { render } from "./TableInvoiceConsignments.vue?vue&type=template&id=0e510a21"
import script from "./TableInvoiceConsignments.vue?vue&type=script&lang=ts"
export * from "./TableInvoiceConsignments.vue?vue&type=script&lang=ts"
script.render = render

export default script